export const getLegacyRedirectPath = (
  pathname: string,
  fromPrefix: string,
  toPrefix: string,
): string => `${toPrefix}${pathname.slice(fromPrefix.length)}`;

export const getLegacyEditRedirectPath = (toPrefix: string, entityId: string): string =>
  `${toPrefix}/edit/${entityId}`;
